export default "__VITE_ASSET__BZCF9Pgr__"